import {RouterNav} from "./router/Router";

function App() {
  return (
    <>
      <main className="" style={{"width":"100%", "height":"100%"}}>
        <RouterNav/>
      </main>
    </>
  );
}

export default App;
